// resources/js/Layouts/AuthenticatedLayout.tsx
import React from 'react';
import { usePage } from '@inertiajs/react';
import Authenticated from './AuthenticatedLayout';
import SideBar from './SideBar';
import AuthWelcome from './AuthWelcome';
import { useTheme } from './ThemeContext';
import { ConfigProvider, theme as antdTheme } from 'antd';
import AuthDoctor from './AuthDoctor';

interface Props {
    children: React.ReactNode;
}

const AuthLayout: React.FC<Props> = ({ children }) => {
    const { auth }: any = usePage().props;
    const { theme, toggleTheme } = useTheme();

    return (
        <>
            <ConfigProvider
                theme={{
                    algorithm: theme === 'dark' ? antdTheme.darkAlgorithm : antdTheme.defaultAlgorithm,
                }}
            >

                {auth?.user ? (
                    auth.user.roles === 'Admin' ? (
                        <Authenticated user={auth.user}>
                            <SideBar user={auth.user}>
                                <main>{children}</main>
                            </SideBar>
                        </Authenticated>
                    )
                     : auth.user.roles === 'Staff' ? (
                        <Authenticated user={auth.user}>
                            <SideBar user={auth.user}>
                                <main>{children}</main>
                            </SideBar>
                        </Authenticated>
                    )
                        :
                        (
                            <AuthDoctor user={auth.user}>
                                <main >{children}</main>
                            </AuthDoctor>
                        )
                ) : (
                    <AuthWelcome>
                        <main>{children}</main>
                    </AuthWelcome>
                )}

            </ConfigProvider>
        </>
    );
};

export default AuthLayout;
